// Stripe
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { useStripeError } from "./useStripeError";
import { usePaymentMethodSetup } from "@modules/PaymentProcessing/hooks/usePaymentMethodSetup";

interface Props {
  name: string;
  onSuccess: () => void;
  onError: () => void;
  enabled?: boolean;
}

export const useSetupIntent = ({
  name,
  onSuccess,
  onError,
  enabled,
}: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { setupConfig, isLoading } = usePaymentMethodSetup({
    paymentMethod: PaymentMethodType.CREDIT_CARD,
    provider: "stripe",
    enabled,
  });
  const { stripeError, setStripeError } = useStripeError();

  const stripe = useStripe();
  const elements = useElements();

  const addCard = async () => {
    return await stripe.confirmCardSetup(setupConfig.clientSecret as string, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name,
        },
      },
    });
  };

  const submit = useDataMutation(async () => {
    try {
      const result = await addCard();

      const { error } = result;
      if (!!error) {
        setStripeError(error);
      } else onSuccess();
    } catch (error) {
      console.error(error);

      onError();
      throw new Error(error);
    }
  });

  const cleanError = () => {
    setStripeError(undefined);
  };

  return {
    submit,
    stripeError,
    cleanError,
    setStripeError,
    isLoading,
  };
};
